const other = {
  state: {
    page: 1,
  },
  mutations: {
    SET_PAGE(state, page) {
      state.page = page
    }
  }
}
export default other


// WEBPACK FOOTER //
// ./src/store/modules/other.js